import { Wishlist } from '@/screens/WishListPage/WishList';

export default Wishlist;
